import type { Configuration, PopupRequest } from "@azure/msal-browser";

// MSAL configuration for "Sign in with Microsoft" (AUTH_TYPE === "AzureAD").
// Mirrors Triyo.Addin.Web/src/authConfigAzureAd.js.
export const msalConfig: Configuration = {
  auth: {
    clientId: window.APP_SETTINGS?.REACT_APP_AUTH_CLIENT_ID ?? "",
    authority: window.APP_SETTINGS?.REACT_APP_AUTH_AUTHORITY ?? "",
    redirectUri: window.APP_SETTINGS?.REACT_APP_AUTH_REDIRECT_URI ?? "",
  },
};

export const loginRequest: PopupRequest = {
  scopes: ["User.Read", "Chat.ReadWrite", "ChatMessage.Send", "offline_access"],
};
